import AppHeader from '@/containers/V3/AppHeader/AppHeader';
import { CATEGORY_KEYWORD_LIST } from './_const';
import useWebview from '@/hooks/V3/useWebview';
import { useRecoilValue } from 'recoil';
import { deviceUuidState, safeAreaInsetsState } from '@/store/atom';
import { RootState, useAppSelector } from '@/redux/store';
import { useLog } from '@/hooks/V3/useLog';

const HighAndLowCategoryList = () => {
  const { postMessage } = useWebview();
  const safeAreaInsets = useRecoilValue(safeAreaInsetsState);
  const user = useAppSelector((state: RootState) => state.user);
  const { setUserEventHistory } = useLog(user.UserNo);
  const deviceUuid = useRecoilValue(deviceUuidState);

  return (
    <main
      className="flex h-screen select-none flex-col gap-[12px] bg-white px-[20px]"
      style={{
        paddingTop: safeAreaInsets.topInset,
        paddingBottom: safeAreaInsets.bottomInset,
      }}
    >
      <AppHeader title={'키워드 게임'} />
      <div className="flex w-full flex-grow flex-col items-center overflow-y-auto pb-[24px] scrollbar-hide">
        <div className="my-[20px] text-gr-900 Title3S18">카테고리를 선택하세요</div>
        <div className="flex w-full flex-col gap-[8px]">
          {CATEGORY_KEYWORD_LIST.map((item) => (
            <div
              key={item.title}
              className="flex w-full items-center gap-[12px] rounded-[10px] bg-gr-50 p-[10px]"
              onClick={() => {
                postMessage({
                  action: 'navigateApp',
                  data: {
                    key: 'HighAndLowGame',
                    name: 'HighAndLowGame',
                    params: {
                      gameCategory: item.title,
                    },
                  },
                });

                setUserEventHistory({
                  eventName: 'select_game_category',
                  eventValue: item.title,
                  deviceUuid,
                });
              }}
            >
              <span>
                <item.icon />
              </span>
              <span className="text-gr-700 Body1S16">{item.title}</span>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default HighAndLowCategoryList;
